module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO9DecisionesEfectivas  (ant40).caee6f6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO9DecisionesEfectivas  (ant40).mp4
// module id = 815
// module chunks = 1